import { useTranslation } from 'react-i18next';

import { useItemData } from 'services/item/useItemData';
import { PurchaseDto } from 'services/order/orderService.dto';
import { convertToThumbnail300 } from 'utils/thumbnails';

import DataDetails from './DataDetails';

interface Props {
  purchase: PurchaseDto;
}

const PurchaseDetails = ({ purchase }: Props) => {
  const { content } = useItemData(purchase.itemId);
  const { t } = useTranslation('checkout');

  const prepareContent = () => {
    if (content) {
      return { name: content.title, image: convertToThumbnail300(content.imageUrlList[0]) };
    }
  };

  return (
    <DataDetails header={`${t('buyer-reassignment.purchase')}:`} isCircleImage={false} content={prepareContent()} />
  );
};

export default PurchaseDetails;
